import { Col, Progress, Row } from 'antd';
import React, { FC, useEffect } from 'react';
import {
    RightCircleOutlined
  } from '@ant-design/icons';
  import './listAnalyticsSubjectCards.scss'
  import ScoreIcon from "../../../../assets/icons/reward.svg";
import AccuracyIcon from "../../../../assets/icons/dart.svg";
import SpeedIcon from "../../../../assets/icons/sketch.svg";
import DurationIcon from "../../../../assets/icons/sand-clock.svg";

interface SubjectsProps {
    subjects: any[],
    onClick: (id: any, name: any) => void,
    showProgress: boolean
}
const ListAnalyticsSubjectCards:FC<SubjectsProps> = ({subjects, onClick, showProgress}) => {
   
    return( 
        <Row className="list__subjects">
               {subjects?.map((value, index) => {
            return (
              <Col span={7} className="subject__card" onClick={() => onClick(value.id, value.name || value.title)}>
                  <div className="subject-card__header">
                      <div className=""> 
                      <p className="subject">{value?.name || value?.title}</p>
                      <div className="subject__rank">Rank 04</div>
                      </div>
                    <RightCircleOutlined />
                  </div>
                  {
                      showProgress &&
                    <div className="subject-card__progress">
                    <p className="progress">Progress</p>
                    <div className="flex align-center subject-card-progress__content">
                        <img src={ScoreIcon}/>
                        <p>Content learnt <span>(23<span>/89</span>)</span></p>
                        <Progress type="circle" percent={30} width={30} strokeColor={'#ED4C8A'}/>
                    </div>
                    <div className="flex align-center subject-card-progress__content">
                        <img src={AccuracyIcon}/>
                        <p>Exercise attempted <span>(23<span>/89</span>)</span></p>
                        <Progress type="circle" percent={30} width={30} strokeColor={'#7E48AB'}/>
                    </div>
                  </div>
                  }
                  
                  <div className={`subject-card__performance ${!showProgress && "mt-5"}`}>
                   {showProgress && <p className="performance">Performance</p>}
                    <div className="flex align-center subject-card-performance__content">
                        <img src={ScoreIcon}/>
                        <p className="subject-card-performance__measure">Score</p>
                        <p className="subject-card-performance-measure__value">67</p>
                    </div>
                    <div className="flex align-center subject-card-performance__content">
                        <img src={SpeedIcon}/>
                        <p className="subject-card-performance__measure">Speed</p>
                        <p className="subject-card-performance-measure__value">01 <span>sec/ques</span></p>
                    </div>
                    <div className="flex align-center subject-card-performance__content">
                        <img src={AccuracyIcon}/>
                        <p className="subject-card-performance__measure">Accuracy</p>
                        <p className="subject-card-performance-measure__value">80%</p>
                    </div>
                    <div className="flex align-center subject-card-performance__content">
                        <img src={DurationIcon}/>
                        <p className="subject-card-performance__measure">Duration</p>
                        <p className="subject-card-performance-measure__value">1<span>d</span> 11<span>h</span> 23<span>m</span></p>
                    </div>
                  </div>
              </Col>
            )
        })     }
        </Row>
        
    )
}
export default ListAnalyticsSubjectCards